import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import UA from '../../utils/ua';
import './style.less';

class AchievementRulesPage extends Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render(){
        return(
            <DocumentTitle title={'成就规则'}>
                <div className={`container achievementrules ${UA.mobileClient?'':'pc'}`}>
                    {!UA.mobileClient && <h1>成就规则</h1>}
                    <p>•<span>成就代表爱课AirCourse平台对您学习的认可，每一个成就都有不同的价值。</span></p>

                    <p>•<span>在爱课达成不同的目标，就可以获得并升级各个成就，每个成就等级对应一个不同的图标，逐渐升级成就即可解锁新的图标。</span></p>

                    <p>•<span>每个成就的获得都可以获得成就点，成就等级越高获得的成就点也越高，成就点累计到特定点数可以获得奖励。</span></p>

                    <p>•<span>活动类成就，只能在完成某些活动后获得，在该活动结束后，如果您未获得该成就，该成就的图标就会消失。</span></p>
                </div>
            </DocumentTitle>
        )
    }
}

export default AchievementRulesPage;



// WEBPACK FOOTER //
// ./src/components/customerPage/achievementRules.jsx